import React, { useState } from 'react';
import UnstyledButton from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/UnstyledFilterButton';
import _clone from 'lodash/clone';
import {
  ButtonGroup,
  EditInput
} from 'src/components/BeaconV2Components/GenericSidebarNav/AdvertisingEditFields/EditInput';
import { SelectedIncludeCheckbox, SelectExcludeCheckbox, SelectIncludeCheckbox } from 'src/components/SvgIcons';
import { useAppSelector, useSnackbar } from 'src/utils/Hooks';

import { fetchMainEntity } from 'src/store/modules/entityService/operations';
import { useDispatch } from 'react-redux';
import { updateCampaign } from 'src/components/AdManager/AmsUtils';
import { CustomLoading } from 'src/components/common/Loading/PlaceHolderLoading/PlaceHolderLoading';
import { checkInstacartRetailer } from 'src/utils/app';
import {
  MINIMUM_BUDGET_MIN_VALUE,
  DAILY_BUDGET_THRESHOLD_ERROR
} from 'src/components/BeaconV2Components/GenericSidebarNav/AdvertisingEditFields/MinimumCampaignBudget';

const DailyCampaignBudget = () => {
  const { showSnackbar } = useSnackbar();
  const [isFocus, setIsFocus] = useState(false);
  const currentEntity = useAppSelector((state) => state.entityService.mainEntity);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const currentDailyBudget = currentEntity?.extendedAttributes?.liveBudgetSetting?.amount;
  const currentMinimumBudget =
    currentEntity?.extendedAttributes?.automationAttributes?.metricsThresholds?.budgetAmountMinimum ||
    MINIMUM_BUDGET_MIN_VALUE;
  const [budget, setBudget] = useState<string | undefined>();

  // Reset the input value. Display placeholder value.
  const resetBudget = () => {
    setBudget(undefined);
    setIsFocus(false);
  };

  const saveBudget = async () => {
    try {
      const budgetValue = +budget || MINIMUM_BUDGET_MIN_VALUE;

      // Validate that daily budget is not less than minimum budget
      if (budgetValue < currentMinimumBudget) {
        showSnackbar({
          message: DAILY_BUDGET_THRESHOLD_ERROR,
          type: 'error'
        });
        resetBudget();
        return;
      }

      const mainEntityCloned: any = _clone(currentEntity);
      delete mainEntityCloned.adCampaignProducts;
      delete mainEntityCloned.adTargets;
      delete mainEntityCloned.adGroups;
      mainEntityCloned.extendedAttributes.currentMonthBudgetSetting = {
        ...mainEntityCloned.extendedAttributes.currentMonthBudgetSetting,
        amount: budgetValue
      };
      setLoading(true);
      resetBudget();
      await updateCampaign(mainEntityCloned);
      await dispatch(
        fetchMainEntity(mainEntityCloned.type, mainEntityCloned.id, mainEntityCloned.extendedAttributes.retailerId)
      );
      showSnackbar({
        message: 'Budget saved successfully.',
        type: 'success'
      });
      setLoading(false);
    } catch (error) {
      showSnackbar({
        message: 'Error saving budget, please try again later.',
        type: 'error'
      });
      console.error('Error saving budget', error);
      resetBudget();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        className="field-title"
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '12px'
        }}
      >
        Daily Budget
        <ButtonGroup className={isFocus ? 'focus' : ''}>
          <UnstyledButton onClick={() => {}}>
            {budget ? (
              <SelectedIncludeCheckbox onClick={saveBudget} style={{ width: '16px', height: '16px' }} />
            ) : (
              <SelectIncludeCheckbox style={{ width: '16px', height: '16px' }} />
            )}
          </UnstyledButton>
          <UnstyledButton onClick={resetBudget}>
            <SelectExcludeCheckbox style={{ width: '16px', height: '16px' }} />
          </UnstyledButton>
        </ButtonGroup>
      </div>
      <div className="field-subtitle">
        {loading ? (
          <CustomLoading height={12} width={88} padding={0} />
        ) : (
          <EditInput
            onFocus={() => {
              setIsFocus(true);
            }}
            onBlur={() => {
              if (!budget || budget === currentDailyBudget) {
                setIsFocus(false);
              }
            }}
            disabled={checkInstacartRetailer()}
            prefix="$"
            placeholder={currentDailyBudget}
            value={budget}
            onChange={(e) => setBudget(e.target.value)}
          />
        )}
      </div>
    </div>
  );
};

export default DailyCampaignBudget;
